import {
    ALERT_FIELD_VALUE_CHANGE,
    ALERT_RESET_FIELD_VALUE,
    REPORT_FIELD_VALUE_CHANGE,
    REPORT_RESET_FIELD_VALUE,
    GET_SETTINGS,
    GET_REPORTS_LIST,
    GET_ALERTS_LIST,
    EDIT_ALERT,
    EDIT_ALERT_VALUES,
    CREATE_ALERT,
    CREATE_REPORT,
    RESET_REPORT_FORM,
    RESET_ALERT_FORM,
    EDIT_REPORT,
    EDIT_REPORT_VALUES,
    UPDATE_REPORT,
    DISABLE_ALERT,
    DELETE_REPORT_PROMPT,
    UPDATE_ALERT,
    SET_DEFAULT_EMAIL,
} from "../actions/reportsAndAlertsActions";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import { reportSettings } from "../components/MainContent/ReportsAndAlerts/reportSettings";

const alertIntitalValues = {
    alertName: "",
    alertType: null,
    period: null,
    sentiment: [],
    accountType: null,
    publications: [],
    locations: [],
    topics: [],
    topicsSelected: [],
    subtopics: null,
    mailTo: "",
    keywords: "",
    operator: null,
    operatorValue: "",
    entityType: [],
    entitySubtype: [],
    excludePost: false,
    sendAsEmail: false,
    sendAsHourlyEmail: false,
    cloneToCollection: false,
    collectionData: null,
    platform: [],
    language: [],
};

const reportIntitalValues = {
    reportName: "",
    reportType: null,
    deliveryTime: null,
    frequency: null,
    weekday: null,
    monthday: null,
    startDate: null,
    endDate: null,
    locations: [],
    platforms: [],
    languages: [],
    topics: [],
    topicsOptions: null,
    topicsSelected: [],
    mailTo: "",
    keywords: "",
    customDashboard: null,
    sentiment: [],
    entityType: [],
    entitySubtype: [],
};

const setEditReportValues = (report) => {
    const activeFields = reportSettings[+report.interval];
    const reportFieldValues = {
        reportName: "",
        reportType: null,
        deliveryTime: null,
        frequency: null,
        weekday: null,
        monthday: null,
        startDate: null,
        endDate: null,
        locations: [],
        platforms: [],
        languages: [],
        sentiment: [],
        entityType: [],
        entitySubtype: [],
        topics: [],
        topicsSelected: [],
        mailTo: "",
        keywords: "",
        topicsOptions,
        customDashboard: null,
    };
    // {
    //     frequency: true,
    //     weekday: false,
    //     monthday: false,
    //     dateRange: false,
    //     locations: false,
    //     platforms: false,
    //     languages: false,
    //     topics: false,
    //     keywords: false,
    //     customDashboard: true,
    // }
    reportFieldValues.reportName = report.name;
    reportFieldValues.mailTo = report.email_sent_to;
    reportFieldValues.deliveryTime = report.email_sent_to;
};

const reportsAndAlertsReducer = (
    state = {
        settings: null,
        alertFieldValues: JSON.parse(JSON.stringify(alertIntitalValues)),
        reportFieldValues: JSON.parse(JSON.stringify(reportIntitalValues)),
        reportsList: null,
        total_report_in_company: 0,
        topicsOptions: null,
        locationOptions: null,
        reportTypesOptions: null,
        alertTypesOptions: null,
        editItem: null,
        editActionItem: null,
        platformOptions: null,
        // customDashboardOptions: null,
        reportsListFetching: false,
        reportsListError: null,
        submittingReportForm: false,
        submittedReportForm: false,
        editReport: null,
        alertsList: null,
        total_alert_in_company: 0,
        alertsListFetching: false,
        alertsListError: null,
        submittingAlertForm: false,
        submittedAlertForm: false,
        editAlert: null,
        disableAlert: null,
        deleteReport: null,
        userEmail: "",
    },
    action,
) => {
    switch (action.type) {
        case isFulfilled(GET_SETTINGS):
            return {
                ...state,
                settings: action.payload,
            };
        case ALERT_FIELD_VALUE_CHANGE:
            return { ...state, alertFieldValues: { ...state.alertFieldValues, [action.field]: action.value } };
        case ALERT_RESET_FIELD_VALUE:
            return { ...state, alertFieldValues: { ...state.alertFieldValues, [action.field]: alertIntitalValues[action.field] } };
        case REPORT_FIELD_VALUE_CHANGE:
            return { ...state, reportFieldValues: { ...state.reportFieldValues, [action.field]: action.value } };
        case REPORT_RESET_FIELD_VALUE:
            return { ...state, reportFieldValues: { ...state.reportFieldValues, [action.field]: reportIntitalValues[action.field] } };
        case isFulfilled(GET_REPORTS_LIST):
            return {
                ...state,
                reportsList: action.payload.reports.sort((a, b) => b.id - a.id),
                reportsListFetching: false,
                reportsListError: null,
                total_report_in_company: action.payload.total_report_in_company,
            };
        case isPending(GET_REPORTS_LIST):
            return { ...state, reportsList: null, reportsListFetching: true, reportsListError: null, total_report_in_company: 0 };
        case isFulfilled(GET_ALERTS_LIST):
            return {
                ...state,
                alertsList: action.payload.alerts.sort((a, b) => b.id - a.id),
                alertsListFetching: false,
                alertsListError: null,
                total_alert_in_company: action.payload.total_alert_in_company,
            };
        case isPending(GET_ALERTS_LIST):
            return { ...state, alertsList: null, alertsListFetching: true, alertsListError: null, total_alert_in_company: 0 };
        case isPending(CREATE_REPORT):
            return { ...state, submittingReportForm: true, submittedReportForm: false };
        case isFulfilled(CREATE_REPORT):
            if (action.payload && action.payload.response && action.payload.response.status === 400) {
                return { ...state, submittingReportForm: false, submittedReportForm: false };
            } else {
                return { ...state, submittingReportForm: false, submittedReportForm: true };
            }
        case isPending(UPDATE_REPORT):
            return { ...state, submittingReportForm: true, submittedReportForm: false };
        case isFulfilled(UPDATE_REPORT):
            if (action.payload && action.payload.response && action.payload.response.status === 400) {
                return { ...state, submittingReportForm: false, submittedReportForm: false };
            } else {
                return { ...state, submittingReportForm: false, submittedReportForm: true };
            }
        case RESET_REPORT_FORM:
            return { ...state, reportFieldValues: { ...JSON.parse(JSON.stringify(reportIntitalValues)), mailTo: state.userEmail }, editReport: null };
        case RESET_ALERT_FORM:
            return { ...state, alertFieldValues: { ...JSON.parse(JSON.stringify(alertIntitalValues)), mailTo: state.userEmail }, editAlert: null };
        case EDIT_REPORT: {
            const editReport = action.payload;
            return { ...state, editReport };
        }
        case EDIT_REPORT_VALUES:
            return { ...state, reportFieldValues: action.payload };
        case EDIT_ALERT: {
            const editAlert = action.payload;
            return { ...state, editAlert };
        }
        case EDIT_ALERT_VALUES:
            return { ...state, alertFieldValues: action.payload };
        case isPending(CREATE_ALERT):
            return { ...state, submittingAlertForm: true, submittedAlertForm: false };
        case isFulfilled(CREATE_ALERT):
            if (action.payload && action.payload.response && action.payload.response.status === 400) {
                return { ...state, submittingAlertForm: false, submittedAlertForm: false };
            } else {
                return { ...state, submittingAlertForm: false, submittedAlertForm: true };
            }

        case "TOPICS_OPTIONS":
            return {
                ...state,
                topicsOptions: action.payload.topicsOptions,
            };
            break;

        // case "CUSTOM_DASHBOARD_OPTIONS":
        //     return {
        //         ...state,
        //         customDashboardOptions: action.payload.customDashboardOptions,
        //     };
        //     break;

        case "PLATFORM_OPTIONS":
            return {
                ...state,
                platformOptions: action.payload.platformOptions,
            };
            break;

        case "LOCATION_OPTIONS":
            return {
                ...state,
                locationOptions: action.payload.locationOptions,
            };
            break;

        case "EDIT_REPORT_ITEM":
            return {
                ...state,
                editItem: action.payload.editItem,
            };
            break;

        case "EDIT_ALERT_ITEM":
            return {
                ...state,
                editActionItem: action.payload.editActionItem,
            };
            break;

        case "REPORT_TYPE_OPTIONS":
            return {
                ...state,
                reportTypesOptions: action.payload.reportTypesOptions,
            };
            break;

        case "ALERT_TYPE_OPTIONS":
            return {
                ...state,
                alertTypesOptions: action.payload.alertTypesOptions,
            };
            break;

        case isPending(UPDATE_ALERT):
            return { ...state, submittingAlertForm: true, submittedAlertForm: false };
        case isFulfilled(UPDATE_ALERT):
            if (action.payload && action.payload.response && action.payload.response.status === 400) {
                return { ...state, submittingAlertForm: false, submittedAlertForm: false };
            } else {
                return { ...state, submittingAlertForm: false, submittedAlertForm: true };
            }
        case DISABLE_ALERT:
            return { ...state, disableAlert: action.payload };
        case DELETE_REPORT_PROMPT:
            return { ...state, deleteReport: action.payload };
        case SET_DEFAULT_EMAIL:
            return {
                ...state,
                userEmail: action.payload,
                alertFieldValues: { ...state.alertFieldValues, mailTo: action.payload },
                reportFieldValues: { ...state.reportFieldValues, mailTo: action.payload },
            };
        default:
            return state;
    }
};

export default reportsAndAlertsReducer;
